// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__23I4K","detailsBorder":"styles_detailsBorder__35ACI"};